export const userPreferencesActionNames = {
  SET_USERNAME: "SET_USERNAME",
  SET_DISPLAYNAME: "SET_DISPLAYNAME",
  SET_LOGIN_FLAG: "SET_LOGIN_FLAG",
  SET_EMAIL: "SET_EMAIL",
  UPDATE_PROFILE_SETTINGS: "UPDATE_PROFILE_SETTINGS",
};

export const setUserName = (payload) => {
  return {
    type: userPreferencesActionNames.SET_USERNAME,
    payload: payload,
  };
};

export const setDisplayName = (payload) => {
  return {
    type: userPreferencesActionNames.SET_DISPLAYNAME,
    payload: payload,
  };
};

export const setLoginFlag = (payload) => {
  return {
    type: userPreferencesActionNames.SET_LOGIN_FLAG,
    payload: payload,
  };
};

export const setEmail = (payload) => {
  return {
    type: userPreferencesActionNames.SET_EMAIL,
    payload: payload,
  };
};

export const updateProfileSettings = (payload) => {
  return {
    type: userPreferencesActionNames.UPDATE_PROFILE_SETTINGS,
    payload: payload,
  };
};
